import { useState, useRef } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import { useTranslation } from 'react-i18next';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { CustomDot } from './components/dot';
import { CustomTooltip } from './components/tooltip';
import s from './index.module.scss';

export const Chart = ({ data }) => {
  const { t } = useTranslation('calculator');
  const [hovered, setHovered] = useState(null);
  const containerRef = useRef(null);

  return (
    <>
      <div ref={containerRef} className={s.graph}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{ top: 20, right: 40, left: 0, bottom: 0 }}
          >
            <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
            <XAxis
              dataKey="date"
              tickFormatter={value =>
                data.length > 12
                  ? prettyDate(value, 'MMM YYYY')
                  : prettyDate(value, 'MMM')
              }
              tick={{ fontSize: 12 }}
              stroke="var(--Grey-800-Extra-Dark, #8497A6)"
            />
            <YAxis
              tickFormatter={value => prettyFloatMoney(value)}
              tick={{ fill: '#999', fontSize: 12 }}
              domain={[dataMin => dataMin * 0.99, 'auto']}
              stroke="var(--Grey-800-Extra-Dark, #8497A6)"
            />
            <Tooltip content={<></>} wrapperStyle={{ display: 'none' }} />
            <Line
              type="monotone"
              dataKey="earnings"
              stroke="#a07d2c"
              strokeWidth={2}
              dot={props => (
                <CustomDot
                  {...props}
                  dataKey="earnings"
                  hovered={hovered}
                  setHovered={setHovered}
                  containerRef={containerRef}
                />
              )}
              activeDot={false}
            />
            <Line
              type="monotone"
              dataKey="contributions"
              stroke="#f7931a"
              strokeWidth={2}
              dot={props => (
                <CustomDot
                  {...props}
                  dataKey="contributions"
                  hovered={hovered}
                  setHovered={setHovered}
                  containerRef={containerRef}
                />
              )}
              activeDot={false}
            />
            <Legend
              iconSize={8}
              verticalAlign="bottom"
              style={{ fontSize: '12px', lineHeight: '20px' }}
              align="left"
              iconType="circle"
              formatter={value => {
                if (value === 'earnings')
                  return t('graph.projected_earnings_value');
                if (value === 'contributions')
                  return t('graph.total_contributions');
                return value;
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Tooltip absolutely positioned */}
      {hovered && (
        <div
          style={{
            position: 'fixed',
            left: hovered.x,
            top: hovered.y - 14, // Amount above the dot
            transform: 'translate(-50%, -100%)',
            pointerEvents: 'none',
            zIndex: 10,
          }}
        >
          <CustomTooltip data={data} hovered={hovered} />
        </div>
      )}
    </>
  );
};
